import { getFunctions, type Functions } from "firebase/functions";
import { getFirebaseApp } from "./config";

let functions: Functions | null = null;

export function getFunctionsAsia(): Functions {
  const app = getFirebaseApp();
  if (!app) throw new Error("Firebase not configured");
  if (!functions) functions = getFunctions(app, "asia-south1");
  return functions;
}
